import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon } from 'semantic-ui-react';
import * as ReactDOM from 'react-dom';

class Dialog extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    afterClose: PropTypes.func,
    callback: PropTypes.func,
    type: PropTypes.oneOf([
      'positive',
      'negative',
      'info',
      'primary',
    ]),
    name: PropTypes.string,
    color: PropTypes.string,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    afterClose: () => { },
    callback: null,
    type: 'positive',
    name: 'info',
    color: 'blue',
    loading: false,
  };

  onUnmount = () => {
    const { afterClose } = this.props;
    afterClose();
  };

  handleClose = () => {
    const { close, callback } = this.props;
    if (callback) {
      callback();
    }
    close();
  };

  handleCancel = () => {
    const { close } = this.props;
    close();
  }

  render() {
    const {
      title, content, visible, type, name, color, callback, loading,
    } = this.props;

    return (
      <Modal
        open={visible}
        onUnmount={this.onUnmount}
        size="mini"
      >
        {
          title && (
            <Modal.Header>
              <Icon name={name} color={color} />
              {title}
            </Modal.Header>
          )
        }
        <Modal.Content>
          <p>{content}</p>
        </Modal.Content>
        <Modal.Actions>
          {
            callback !== null && (
              <Button onClick={this.handleCancel}>
                Cancel
              </Button>
            )
          }

          <Button
            size="small"
            onClick={this.handleClose}
            className={type}
            loading={loading}
            disabled={loading}
          >
            Ok
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default function confirm(config) {
  const div = document.createElement('div');
  document.body.appendChild(div);

  function destroy() {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  function render(props) {
    ReactDOM.render(React.createElement(Dialog, props), div);
  }

  function close() {
    render({
      ...config,
      close,
      visible: false,
      afterClose: destroy.bind.apply(destroy),
    });
  }

  render({ ...config, visible: true, close });

  return {
    destroy: close,
  };
}
